import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const TakeawayTabs = ({ tabs, activeIndex, onTabChange }) => {
  // ...same Swiper setup as before
  return (
    <div className="mSectionTopCol">
      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: '.menuTabNext',
          prevEl: '.menuTabPrev',
        }}
        slidesPerView="auto"
        spaceBetween={30}
        speed={500}
        className="menuSwiper"
        breakpoints={{
          1199: { spaceBetween: 50 },
        }}
      >
        {tabs.map((tab, index) => (
          <SwiperSlide className="w-auto" key={tab.category_id}>
            <button
              className={`nav-link${index === activeIndex ? ' active' : ''}`}
              id={`tab-${tab.category_slug}`}
              type="button"
              role="tab"
              aria-controls={`content-${tab.category_slug}`}
              aria-selected={index === activeIndex ? 'true' : 'false'}
              onClick={() => onTabChange(index)}
            >
              {tab.category_name}
            </button>
          </SwiperSlide>
        ))}

        <div className="swiperButtonNext menuTabNext">
          <svg width="9" height="12" className="swiperArrow">
            <use href="./images/sprite.svg#iconNextSwiper"></use>
          </svg>
        </div>
        <div className="swiperButtonPrev menuTabPrev">
          <svg width="9" height="12" className="swiperArrow">
            <use href="./images/sprite.svg#iconPrevSwiper"></use>
          </svg>
        </div>
      </Swiper>
    </div>
  );
};

export default TakeawayTabs;
